import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackbaseCoreModule } from '@backbase/foundation-ang/core';
import { TransactionsListWidgetExtendedComponent } from './transactions-list-widget-extended.component';
import { TransactionsListWidgetModule } from '@backbase/retail-ang';
import { BnTransactionListItemComponent } from './bn-transaction-list-item/bn-transaction-list-item.component';
import { BnTransactionItemDetailsComponent } from './bn-transaction-item-details/bn-transaction-item-details.component';
import { BnTransactionsFilterComponent } from './bn-transaction-filter/bn-transaction-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BnTransactionsListComponent } from './bn-transactions-list/bn-transactions-list.component';
import { AmountInputModule } from '@backbase/ui-ang';

import { BadgeCounterModule } from './badge-counter/badge-counter.module';
import { BnSemaphoreTooltipModule } from 'bn-semaphore-tooltip';
import { UIComponentModule } from 'ui-components';
import { BnEsDatePipeModule } from 'bn-es-date-pipe';
import { BnEmptyPipeModule } from 'bn-empty-pipe';
import { BnOtPErrorComponent } from './banesco-otp-error/banesco-otp-error.component';
@NgModule({
  declarations: [
    TransactionsListWidgetExtendedComponent,
    BnTransactionListItemComponent,
    BnTransactionItemDetailsComponent,
    BnTransactionsFilterComponent,
    BnTransactionsListComponent,
    BnOtPErrorComponent,
  ],
  imports: [
    CommonModule,
    TransactionsListWidgetModule,
    BnEmptyPipeModule,
    BnEsDatePipeModule,
    BackbaseCoreModule.withConfig({
      classMap: { TransactionsListWidgetExtendedComponent },
    }),
    FormsModule,
    ReactiveFormsModule,
    AmountInputModule,
    UIComponentModule,
    BnSemaphoreTooltipModule,
    BadgeCounterModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [BnOtPErrorComponent, TransactionsListWidgetExtendedComponent],
})
export class TransactionsListWidgetExtendedModule {}
